import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  FIND_BY_ID_ERROR,
  FIND_BY_ID_REQUEST,
  FIND_BY_ID_SUCCESS,
} from "./ActionType";

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }

  if (typeof response.json === "function") {
    try {
      return await response.json();
    } catch (_error) {
      return null;
    }
  }

  return null;
};

const responseErrorMessage = (payload, response) => {
  const serverMessage =
    (typeof payload === "string" && payload) ||
    [payload?.message, payload?.error, payload?.detail].find(
      (value) => typeof value === "string" && value.trim()
    );

  return serverMessage || `Store details request failed (${response.status})`;
};

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId);
  requestSequence += 1;

  return {
    shopId: normalizedShopId,
    requestId: `storeDetails:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

export const findByIdApi = (shopId) => {
  return async (dispatch) => {
    const meta = createRequestMeta(shopId);
    dispatch(findByIdRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.find_detail}`;

    try {
      const response = await authenticatedFetch(url, {
        method: "POST",
        body: JSON.stringify({
          page: 0,
          pageLength: 10,
          storeId: shopId,
        }),
        credentials: "include",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      });
      const payload = await readResponsePayload(response);

      if (!response.ok) {
        throw new Error(responseErrorMessage(payload, response));
      }

      dispatch(findByIdSuccess(payload, meta));
      return { ok: true, payload };
    } catch (error) {
      const message = error?.message || "Store details request failed";
      dispatch(findByIdError(message, meta));
      return { ok: false, error: message };
    }
  };
};

export const refreshShopifyProfileApi = (shopId) => {
  return async () => {
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.refresh_shopify_profile(
      encodeURIComponent(String(shopId))
    )}`;

    try {
      const response = await authenticatedFetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
          Accept: "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      });
      const payload = await readResponsePayload(response);
      if (!response.ok) {
        throw new Error(responseErrorMessage(payload, response));
      }
      return { ok: true, payload };
    } catch (error) {
      return {
        ok: false,
        error: error?.message || "Shopify profile refresh failed",
      };
    }
  };
};

function findByIdRequest(meta) {
  return {
    type: FIND_BY_ID_REQUEST,
    meta,
  };
}

function findByIdSuccess(data, meta) {
  return {
    type: FIND_BY_ID_SUCCESS,
    payload: data,
    meta,
  };
}

function findByIdError(data, meta) {
  return {
    type: FIND_BY_ID_ERROR,
    payload: data,
    meta,
  };
}
